module.exports = __webpack_public_path__ + "img/elementlengths_jaka.81f11f28.png";